import React, { Fragment, useEffect, useRef } from 'react';
import { translate } from '../Services/translation';

const NavigationItem = ({ links = [], contentLink = null, level = 0 }) => {
  const menuRef = useRef(null);
  const toggleMenu = () => {
    const menu = menuRef.current;
    if (!menu) {
      return;
    }
    const isOpen = menu.classList.toggle('navbar__menu--show');
    if (isOpen) {
      // sub panels are laid out in the parent panel's coordinate space,
      // so a scrolled parent would push the incoming panel out of view
      let parent = menu.parentElement;
      while (parent) {
        if (parent.classList && parent.classList.contains('navbar__menu')) {
          parent.scrollTop = 0;
        }
        parent = parent.parentElement;
      }
    }
    if (!contentLink) {
      document.body.classList.toggle('no-scroll', isOpen);
    }
  };

  useEffect(() => {
    if (contentLink) {
      return undefined;
    }
    const hamburger = document.querySelector('.ham');
    if (!hamburger) {
      return undefined;
    }
    const onHamburgerClick = (event) => {
      event.preventDefault();
      toggleMenu();
    };
    hamburger.addEventListener('click', onHamburgerClick);
    return () => hamburger.removeEventListener('click', onHamburgerClick);
  }, [contentLink]);

  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;
  const hasNameOrChildren = (link) =>
    link.name || (link.links || []).length > 0;
  // links flagged as hamburger in back office only show in the mobile menu
  const mobileOnlyClass = (link) =>
    link.attributes && link.attributes.megaMenuIsHamburger === 'True'
      ? 'navbar__item--mobile-only'
      : '';
  // "hamburger extra" links render as a separate group at the bottom of
  // the mobile menu, below a divider (never shown on desktop)
  const isExtra = (link) =>
    link.attributes && link.attributes.megaMenuIsHamburgerExtra === 'True';
  const leftSide =
    level === 0
      ? links.filter((x) => !x.isRightAligned && !isExtra(x))
      : [];
  const rightSide =
    level === 0 ? links.filter((x) => x.isRightAligned && !isExtra(x)) : [];
  const extraLinks = level === 0 ? links.filter(isExtra) : [];
  level++;

  const toggleSubMenu = (event) => {
    event.preventDefault();
    toggleMenu();
  };

  return (
    <Fragment>
      {contentLink && (
        <Fragment>
          <a
            className={`navbar__link navbar__link--desktop ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{
              __html: '<span>' + contentLink.name + '</span>',
            }}
          ></a>
          <a
            className={`navbar__link navbar__link--mobile ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={(!links.length && contentLink.url) || '#'}
            dangerouslySetInnerHTML={{
              __html: '<span>' + contentLink.name + '</span>',
            }}
            onClick={links.length ? toggleSubMenu : undefined}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 &&
        (level === 2 ? (
        <div className="navbar__menu-container">
          <ul className="navbar__menu" ref={menuRef}>
            <li className="navbar__item navbar__item--back">
              <a
                className="navbar__link navbar__link--back"
                onClick={toggleMenu}
              >
                <i className="navbar__icon--caret-left"></i>
                {translate('general.back')}
              </a>
            </li>
            {contentLink && (
              <li className="navbar__item navbar__item--show-all">
                <a
                  className="navbar__link navbar__link--show-all"
                  href={contentLink.url}
                >
                  {translate('general.show-all')} {contentLink.name}
                </a>
              </li>
            )}
            {links.map(
              (link) =>
                hasNameOrChildren(link) && (
                  <li className="navbar__item" key={link.url}>
                    <NavigationItem
                      links={link.links}
                      contentLink={link}
                      level={level}
                    />
                  </li>
                )
            )}
          </ul>
        </div>
        ) : level === 1 ? (
        <ul className="navbar__menu navbar__menu__top" ref={menuRef}>
          <li className="navbar__item navbar__item--close">
            <a
              className="navbar__link navbar__link--close"
              onClick={toggleMenu}
            >
              <img
                src="/ui/assets/icons/xmark-solid.svg"
                alt="stäng navigationen"
              />
            </a>
          </li>
          {leftSide.map(
            (link) =>
              hasNameOrChildren(link) && (
                <li
                  className={`navbar__item top-navbar-text ${mobileOnlyClass(
                    link
                  )}`}
                  key={link.url}
                >
                  <NavigationItem
                    links={link.links}
                    contentLink={link}
                    level={level}
                  />
                </li>
              )
          )}
          {rightSide.map(
            (link, i) =>
              hasNameOrChildren(link) && (
                <li
                  className={`navbar__item top-navbar-text navbar__item--right ${
                    i === 0 ? 'first' : ''
                  } ${mobileOnlyClass(link)}`}
                  key={link.url}
                >
                  <NavigationItem
                    links={link.links}
                    contentLink={link}
                    level={level}
                  />
                </li>
              )
          )}
          {extraLinks.length > 0 && (
            <li className="navbar__item navbar__item--extra-things">
              <ul>
                {extraLinks.map(
                  (link) =>
                    link.name && (
                      <li key={link.url}>
                        <a className="navbar__link" href={link.url}>
                          {link.name}
                        </a>
                      </li>
                    )
                )}
              </ul>
            </li>
          )}
        </ul>
        ) : (
          <ul className="navbar__menu" ref={menuRef}>
          <li className="navbar__item navbar__item--back">
            <a className="navbar__link navbar__link--back" onClick={toggleMenu}>
              <i className="navbar__icon--caret-left"></i>
              {translate('general.back')}
            </a>
          </li>
          {contentLink && (
            <li className="navbar__item navbar__item--show-all">
              <a
                className="navbar__link navbar__link--show-all"
                href={contentLink.url}
              >
                {translate('general.show-all')} {contentLink.name}
              </a>
            </li>
          )}
          {links.map(
            (link) =>
              hasNameOrChildren(link) && (
                <li className="navbar__item" key={link.url}>
                  <NavigationItem
                    links={link.links}
                    contentLink={link}
                    level={level}
                  />
                </li>
              )
          )}
          </ul>
        ))}
    </Fragment>
  );
};

export default NavigationItem;
